import { FolderableType } from 'apps/folders/static/enums/folderable-type.enum';
import { SelectedFolderableService } from 'apps/folders/static/services/selected-folderable.service';
import * as i0 from "@angular/core";
export class SelectedRiskProfilesService extends SelectedFolderableService {
    constructor() {
        super(...arguments);
        this.RESOURCE_TYPE = FolderableType.RISK_PROFILE;
        this.ITEM_ID_SLICE_KEY = 'riskProfileId';
    }
}
SelectedRiskProfilesService.ɵfac = /*@__PURE__*/ (() => { let ɵSelectedRiskProfilesService_BaseFactory; return function SelectedRiskProfilesService_Factory(__ngFactoryType__) { return (ɵSelectedRiskProfilesService_BaseFactory || (ɵSelectedRiskProfilesService_BaseFactory = i0.ɵɵgetInheritedFactory(SelectedRiskProfilesService)))(__ngFactoryType__ || SelectedRiskProfilesService); }; })();
SelectedRiskProfilesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SelectedRiskProfilesService, factory: SelectedRiskProfilesService.ɵfac });
